import { Dialog } from "armstrong-react";
import React from "react";
import _ from "underscore";
import { isServer } from "./../../core/detection";
import { LocationImageGallery } from "./locationImageGallery";
import "./locationImageGalleryDialog.scss";

interface ILocationImageGalleryDialogProps extends React.Props<LocationImageGalleryDialog> {
  images: IAccomodationLocationImage[];
  selectedImageFileName?: string;
  title: string;
  onGalleryClosed?: () => void;
  imageClicked?: (image: IAccomodationLocationImage) => void;
  nextClicked?: (image: IAccomodationLocationImage) => void;
  prevClicked?: (image: IAccomodationLocationImage) => void;
  isOpen?: boolean;
}

interface ILocationImageGalleryDialogState {
  imageDialogOpen?: boolean;
  selectedImageIndex?: number;
}

export class LocationImageGalleryDialog extends React.Component<ILocationImageGalleryDialogProps, ILocationImageGalleryDialogState> {
  constructor(props: ILocationImageGalleryDialogProps) {
    super(props);
    this.state = { imageDialogOpen: false, selectedImageIndex: 0 };
  }
  private onClose() {
    this.setState({ imageDialogOpen: false }, () => {
      if (this.props.onGalleryClosed) {
        this.props.onGalleryClosed();
      }
    });
  }
  private getCurrentImage() {
    return _.find(this.props.images, im => im.fileName === this.props.selectedImageFileName);
  }
  public componentDidMount() {
    let index = 0;
    if (this.props.selectedImageFileName) {
      const image = _.find(this.props.images, im => im.fileName === this.props.selectedImageFileName);
      index = this.props.images.indexOf(image);
    }
    this.setState({ imageDialogOpen: this.props.isOpen, selectedImageIndex: index });
  }
  public render() {
    const im = this.getCurrentImage();
    return (
      <div>
        {isServer() && im &&
          <div>
            <img id={`img_${im.id}`} alt={im.meta} title={`${im.description ? `${im.description.substr(0, 75)}...` : ""}`}
              src={im.thumbnailUrl} />
            {isServer() &&
              <caption>{im.description}</caption>
            }
          </div>
        }
        <Dialog className="location-image-gallery-dialog" width="100%" height="100%" title={this.props.title} isOpen={this.state.imageDialogOpen} onClose={() => this.onClose()}>
          <LocationImageGallery
            prevClicked={(img) => this.props.imageClicked(img)}
            nextClicked={(img) => this.props.imageClicked(img)}
            images={this.props.images}
            selectedIndex={this.state.selectedImageIndex} />
        </Dialog>
      </div>
    );
  }
}
